import React from "react";
import google from '../assets/google';
import { loadTable2, loadTableHeader2 } from '../helpers/spreadsheet';
import { compareJersey } from '../helpers/compareJersey';
// reactstrap components
import {
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Table,
  Row,
  Col,
} from "reactstrap";

class Table2 extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      data: [],
      header: [],
    };
  }

  componentDidMount() {
    this.methodsToCall();
    setInterval(() => {
      this.methodsToCall();
    }, 60000);
  }

  methodsToCall() {
    window.gapi.load('client', this.initClient);
  }

  initClient = () => {
    window.gapi.client.init({
      apiKey: google.apiKey,
      discoveryDocs: google.googleSheet
    })
      .then(() => {
        loadTable2(this.onLoad, this.props.type);
      })
  }

  onLoad = (data, error) => {
    if (data) {
      this.setState({
        header: data.headers,
        data: data.dataTable,
      });
    }
  }

  renderTableHeader() {
    return this.state.header.map((item, key) => {
      const { value1, value2, value3, value4, value5, value6, value7, value8, value9, value10, value11, value12, value13 } = item //destructuring
      return (
        <tr key={key}>
          <th>{value1}</th>
          <th>{value2}</th>
          <th>{value3}</th>
          {/* <th>{value4}</th> */}
          <th>{value5}</th>
          <th>{value6}</th>
          <th>{value7}</th>
          <th>{value8}</th>
          <th>{value9}</th>
          <th>{value10}</th>
          <th>{value11}</th>
          <th>{value12}</th>
          <th>{value13}</th>
        </tr>
      )
    })
  }

  renderTableData() {
    return this.state.data.map((item, key) => {
      const { value1, value2, value3, value4, value5, value6, value7, value8, value9, value10, value11, value12, value13 } = item;
      var jerseyUrl = compareJersey(value5, this.props.type);
      return (
        <tr key={key}>
          <td>{value1}</td>
          <td>{value2}</td>
          <td>{value3}</td>

          <td>
            {jerseyUrl !== '' &&
              <img
                src={process.env.PUBLIC_URL + '/jersey/' + jerseyUrl + '.png'}
                height="40"
                width="40"
                alt={value5}
              />}
            <p style={{ display: 'inline', marginLeft: '15px' }}>{value5}</p>
          </td>
          <td>{value6}</td>
          <td>{value7}</td>
          <td>{value8}</td>
          <td>{value9}</td>
          <td>{value10}</td>
          <td>{value11}</td>
          <td>{value12}</td>
          <td>{value13}</td>
        </tr>
      )
    })
  }


  render() {
    return (
      <div className="content">
        <Row>
          <Col md="12">
            <Card>
              <CardHeader>
                <CardTitle tag="h4">{this.props.name}</CardTitle>
              </CardHeader>
              <CardBody>
                <div className="table-responsive">
                  <Table className="table" >
                    <thead className="text-primary">
                      {this.renderTableHeader()}
                    </thead>
                    <tbody>
                      {this.renderTableData()}
                    </tbody>
                  </Table>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
}

export default Table2;
